/**
 * When a table grid cell has `list_group_id` but omits `inventory_type` (common on saved templates),
 * resolve the LIST child catalog type from `field_groups` / `groups` rows (`type === 'LIST'`).
 */
export function resolveListGroupListInventTypeId(
  listGroupId: number,
  fieldGroups: readonly unknown[] | null | undefined,
): number {
  if (!Number.isFinite(listGroupId) || listGroupId <= 0) return 0
  if (!Array.isArray(fieldGroups) || fieldGroups.length === 0) return 0
  for (const raw of fieldGroups) {
    if (raw == null || typeof raw !== 'object') continue
    const g = raw as { id?: unknown; type?: unknown; list_invent_object_type_id?: unknown }
    if (Number(g.id) !== listGroupId) continue
    if (String(g.type) !== 'LIST') continue
    const t = Number(g.list_invent_object_type_id)
    return Number.isFinite(t) && t > 0 ? t : 0
  }
  return 0
}
